import { useScrollReveal } from "@/hooks/useScrollReveal";

export function Reveal({ children, className = "", animation = "reveal", threshold = 0.15 }) {
  const [ref, revealed] = useScrollReveal(threshold);

  return (
    <div
      ref={ref}
      className={`${animation} ${revealed ? "revealed" : ""} ${className}`}
    >
      {children}
    </div>
  );
}

export function RevealStagger({ children, className = "", threshold = 0.1 }) {
  const [ref, revealed] = useScrollReveal(threshold);

  return (
    <div
      ref={ref}
      className={`reveal-stagger ${revealed ? "revealed" : ""} ${className}`}
    >
      {children}
    </div>
  );
}
